import React from "react"
import { graphql } from "gatsby"
import Layout from "../../components/Layout/layout"
import SEO from "gatsby-theme-blank/src/components/seo"
import AdditionalInformation from "gatsby-theme-blank/src/components/additional-information"
import ContentTransformer from "gatsby-theme-blank/src/components/Transformers/content-transformer"
import {
  pageEvent,
  pageEventAdditionalInfos,
  evenement,
  eventsItemTitle,
  eventsItemDate,
  eventsItemDateMonth,
  eventsItemDateTo,
  eventsItemDateYear,
  eventsItemTaxo,
  eventImg,
  eventFooter,
  eventFooterBack,
  eventFooterRight,
  eventFooterDate,
  eventPlace,
  eventPlaceIcon,
  eventPlaceTitle,
  socialPanelContainer,
  editButton,
} from "./styles/detailsEvent.module.scss"
import PropTypes from "prop-types"
import {
  dateDayMonthLength,
  dateYearLength,
  coverSpeed,
  dateHourLength,
} from "../../constants"
import Ariane from "gatsby-theme-blank/src/components/Ariane/ariane"
import { useBuildData } from "gatsby-theme-blank/src/hooks/use-build-data"
import {
  EventAdditionalInfos,
  EventsItemDate,
  EventsItemDateTo,
  EventsItemTaxo,
  EventFooterBack,
  EventFooterDate,
  EventPlaceIcon,
  EventPlaceTitle,
} from "./styled-components/evenement-styled"
import AniLink from "gatsby-plugin-transition-link/AniLink"
import FadeIn from "react-fade-in"
import SocialPanel from "gatsby-theme-blank/src/components/SocialMedias/social-panel"
import TransitionFade from "gatsby-theme-blank/src/components/transition-fade"
import { checkHourValue } from "gatsby-theme-blank/src/components/Home/Agenda/utils/check-hour-value"
import EditButton from "gatsby-theme-blank/src/components/EditButton/edit-button"
import { LightBoxImage } from "gatsby-theme-blank/src/components/LightBoxImage/light-box-image"

//-----------------------Query Graphql---------------------------//

export const query = graphql`
  query ($slug: String!) {
    nodeEvenements(path: { alias: { eq: $slug } }) {
      ...EventItems
    }
  }
`
//-----------------------Query Graphql---------------------------//

//-----------------------Parent component---------------------------//
const EvenementTemplate = ({ data, location }) => {
  const buildColors = useBuildData().theme_settings.palette
  const nodeEvenement = data.nodeEvenements
  const allTaxos = nodeEvenement.relationships.field_taxonomie_thematique
    .map((taxo) => {
      return taxo.name
    })
    .join()
  return (
    <Layout>
      <SEO
        title={nodeEvenement.title}
        description={
          "Dans cette page, vous découvrez l'évènement suivant : " +
          nodeEvenement.title +
          ", mais aussi l'ensemble des thématiques suivantes : " +
          allTaxos
        }
        nodeImageUrl={
          nodeEvenement.relationships?.field_image_event?.localFile
            ?.SlugifiedPublicUrl
        }
      />
      <FadeIn delay={250}>
        <Ariane
          pageName="Tous les évènements"
          pageNameLink="/evenements"
          isDetail={true}
          postName={nodeEvenement.title}
        />
        <section className={pageEvent}>
          <EvenementContent colors={buildColors} event={nodeEvenement} />
          <EvenementFooter location={location.href} event={nodeEvenement} />
        </section>
        <EvenementInfos event={nodeEvenement} />
      </FadeIn>
    </Layout>
  )
}
//-----------------------Parent component---------------------------//

//-----------------------Child component/Content---------------------------//

const EvenementContent = ({ event, colors }) => {
  return (
    <>
      <div className={eventImg}>
        <EditButton
          link={"/node/" + event.drupal_internal__nid + "/edit"}
          addedClass={editButton}
        />
        {event.relationships?.field_image_event?.localFile && (
          <LightBoxImage
            type={"node"}
            node={{
              alt: event.field_image_event.alt,
              file: event.relationships.field_image_event.localFile,
            }}
          />
        )}
      </div>
      <article className={evenement}>
        <EventsItemDate className={eventsItemDate}>
          <span className={eventsItemDateMonth}>
            {event.fields.formatted_field_date_de_debut?.slice(
              0,
              dateDayMonthLength
            )}
          </span>
          <span className={eventsItemDateYear}>
            {event.field_date_de_debut?.slice(dateYearLength)}
          </span>
          {checkHourValue(event.fields.formatted_field_date_de_debut) ? null : (
            <span>
              {event.fields.formatted_field_date_de_debut.slice(dateHourLength)}
            </span>
          )}
        </EventsItemDate>
        <h1 className={eventsItemTitle}>
          <p>{event.title}</p>
        </h1>
        {event.fields.formatted_field_date_de_fin && (
          <EventsItemDateTo className={eventsItemDateTo}>
            Jusqu&apos;au {event.fields?.formatted_field_date_de_fin}
          </EventsItemDateTo>
        )}
        {event.relationships.field_taxonomie_thematique?.length > 0 && (
          <EventsItemTaxo className={eventsItemTaxo} role={"list"}>
            {event.relationships.field_taxonomie_thematique.map((taxo) => (
              <AniLink
                cover
                direction="down"
                bg={colors.a_color_gradients.a_dark}
                duration={coverSpeed}
                key={taxo.name}
                to={taxo.path.alias}
                role={"listitem"}
              >
                {taxo.name}
              </AniLink>
            ))}
          </EventsItemTaxo>
        )}
      </article>
      <div>
        {event.body?.processed && (
          <ContentTransformer content={event.body.processed} />
        )}
      </div>
      {event.field_url_lieu && (
        <div className={eventPlace}>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={event.field_url_lieu.uri}
          >
            <EventPlaceIcon
              className={eventPlaceIcon}
              size={30}
              icon="location2"
            ></EventPlaceIcon>
            <EventPlaceTitle className={eventPlaceTitle}>
              {event.field_url_lieu.title}
            </EventPlaceTitle>
          </a>
        </div>
      )}
    </>
  )
}
//-----------------------Child component/Content---------------------------//

//-----------------------Child component/Footer---------------------------//

const EvenementFooter = ({ event, location }) => (
  <>
    <div className={eventFooter}>
      <EventFooterBack className={eventFooterBack}>
        <TransitionFade
          arialabel="Retour à la liste des évènements"
          link="/evenements"
        >
          Retour à la liste des évènements
        </TransitionFade>
      </EventFooterBack>
      <div className={eventFooterRight}>
        <EventFooterDate className={eventFooterDate}>
          {event.created}
        </EventFooterDate>
      </div>
    </div>
    <div className={socialPanelContainer}>
      <SocialPanel location={location} postData={event} />
    </div>
  </>
)
//-----------------------Child component/Footer---------------------------//

//-----------------------Child component/Infos---------------------------//

const EvenementInfos = ({ event }) => (
  <>
    {event.field_infos_complementaires && (
      <EventAdditionalInfos className={pageEventAdditionalInfos}>
        <AdditionalInformation node={event} />
      </EventAdditionalInfos>
    )}
  </>
)
//-----------------------Child component/Infos---------------------------//

//-----------------------Prop-Types---------------------------//

EvenementTemplate.propTypes = {
  data: PropTypes.object.isRequired,
  location: PropTypes.object,
}
EvenementContent.propTypes = {
  event: PropTypes.object.isRequired,
  colors: PropTypes.object,
}
EvenementInfos.propTypes = {
  event: PropTypes.object.isRequired,
}
EvenementFooter.propTypes = {
  event: PropTypes.object.isRequired,
  location: PropTypes.object,
}
//-----------------------Prop-Types---------------------------//

export default EvenementTemplate
